module.exports = __webpack_public_path__ + "./img/right-arrow.cc1272153837a53cf81d5ee6c1f6bc18.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/right-arrow.png
// module id = ./assets/images/right-arrow.png
// module chunks = 0